import React, { useEffect, useState } from 'react';

import { CarouselReducerAction } from '../../CarouselReducer';
import { CarouselControlDots, Child } from '../../CarouselInterfaces';
import {
  useBemBlockClassNames,
  useBemModifierClassNames,
} from '../../hooks/useBemClassNames';

interface DotProps {
  /**
   * Component global class
   */
  componentClass?: string;
  /**
   * Is the current pip the selected one ?
   */
  isSelected: boolean;
  /**
   * Index of the current Pip
   */
  index: number;
  /**
   * Dots settings
   */
  settings: Required<CarouselControlDots>;
  /**
   * Dots Child
   */
  child?: Child;
  /**
   * Carousel global event dispatcher
   **/
  carouselDispatch: (action: CarouselReducerAction) => void;
}

const Dot = ({
  componentClass = 'dot',
  isSelected,
  index,
  carouselDispatch,
  settings,
  child = null,
}: DotProps) => {
  const [mainClasses, setMainClasses] = useState<string[]>([]);

  useEffect(() => {
    const newMainClasses = [
      settings.items.classes?.component
        ? settings.items.classes.component
        : componentClass,
    ];
    if (settings.items.classes?.custom) {
      newMainClasses.push(settings.items.classes.custom);
    }
    setMainClasses(newMainClasses);
  }, [settings, componentClass]);

  const dotClasses = useBemBlockClassNames(mainClasses);
  const dotClassesTintModifier = useBemModifierClassNames(
    mainClasses,
    `${settings.tint}-tint`,
  );
  const dotClassesIsSelectedModifier = useBemModifierClassNames(
    mainClasses,
    'is-selected',
  );

  return (
    <button
      className={`${dotClasses} ${
        settings.tint ? dotClassesTintModifier : ''
      } ${isSelected ? dotClassesIsSelectedModifier : ''}`}
      aria-current={isSelected ? 'true' : 'false'}
      onClick={() =>
        carouselDispatch({
          type: 'goto',
          payload: { newSlideIndex: index, source: 'dot' },
        })
      }
    >
      {child}
      <span className="sr-only">Go to slide {index}</span>
    </button>
  );
};

export default Dot;
